export default {
  aqua: {
    container: "inline-flex items-center cursor-pointer text-text",
    checkbox:
      "w-6 h-6 border-2 border-primary rounded-full flex items-center justify-center",
    checkbox_checked: "bg-primary",
    checkbox_unchecked: "bg-none",
    checkmark: "h-4 w-4 text-white",
    label: "text-sm font-medium",
    label_left: "mr-2",
    label_right: "ml-2",
    placeholder: "w-4 h-4 bg-transparent",
  },

  aqua_large: {
    container: "inline-flex items-center cursor-pointer text-text p-4 rounded-xl hover:bg-primary_lt/10 transition-colors",
    checkbox:
      "w-8 h-8 border-2 border-primary rounded-lg flex items-center justify-center flex-shrink-0",
    checkbox_checked: "bg-primary border-primary",
    checkbox_unchecked: "bg-transparent border-primary",
    checkmark: "h-6 w-6 text-white",
    label: "text-lg font-medium",
    label_left: "mr-4",
    label_right: "ml-4",
    placeholder: "w-6 h-6 bg-transparent",
  },
}